<template>
  <div class="relative" :class="!isKesfet && 'mt-2'">
    <div v-if="buttonType === 'copy'" :title="share.title" @click="copyUrl()">
      <ORawIcon
        :icon="share.icon"
        class="rounded-full u-center cursor-pointer overflow-hidden border border-[#E2E5ED]"
        :class="isKesfet ? 'w-[42px] h-[42px]' : 'w-11 h-11'"
        :style="{ backgroundColor: share.bgColor }"
      />
    </div>
    <div v-else-if="buttonType === 'google'" :title="share.title">
      <OLink
        pure
        target="_blank"
        href="https://news.google.com/publications/CAAqBwgKMIGmrAsw_rDEAw?ceid=TR:tr&oc=3&hl=tr&gl=TR"
        rel="noopener noreferrer nofollow"
      >
        <ORawIcon
          :icon="share.icon"
          class="rounded-full u-center cursor-pointer overflow-hidden text-white"
          :class="isKesfet ? 'w-[42px] h-[42px]' : 'w-11 h-11'"
          :style="{ backgroundColor: share.bgColor }"
        />
      </OLink>
    </div>
    <div v-else :title="share.title" @click="handleClick(share)">
      <ORawIcon
        :icon="share.icon"
        class="rounded-full u-center cursor-pointer overflow-hidden text-white"
        :class="isKesfet ? 'w-[42px] h-[42px]' : 'w-11 h-11'"
        :style="{ backgroundColor: share.bgColor }"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import { computed, defineComponent, useContext, inject } from '@nuxtjs/composition-api';
import { sendReactionCommentLayer } from '@/modules/tracking/scripts/dataLayer';
import { OIcon, OLink, ORawIcon } from '~/modules/common/components/ui';
import { openExternalPopup } from '~/modules/common/utils/helpers';
import { HOST_URL, TWITTER_USERNAME } from '~/constants/config';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { useToast } from '~/composables/useModal';

export default defineComponent({
  components: { OIcon, OLink, ORawIcon },
  props: {
    article: {
      type: Object,
      require: true,
    },
    buttonType: {
      type: String,
      require: false,
    },
    isKesfet: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const { $analyticsEvent, i18n } = useContext();
    const name = props.isKesfet ? inject('dataLayerName')?.value : '';

    const articleUrl = computed(() => {
      return HOST_URL + getArticleUrl({ article: props.article });
    });

    const handleClick = (share) => {
      openExternalPopup(share.url);
      if (!props.isKesfet) $analyticsEvent('Detailpage', 'User_Engagement', share.eventName);
      sendReactionCommentLayer('Share', { article: props.article }, null, name, 'Keşfet', props.buttonType);
    };
    const shareConstant = () => {
      return {
        facebook: {
          url: `http://www.facebook.com/sharer/sharer.php?u=${articleUrl.value}`,
          title: i18n.t('share-button.fb-share'),
          eventName: 'detailpage_Fbshare',
          icon: 'article/facebook',
          bgColor: '#4363A2',
        },
        twitter: {
          url: `https://twitter.com/intent/tweet?via=${TWITTER_USERNAME}&url=${articleUrl.value}&text=${props.article.title}`,
          title: i18n.t('share-button.tw-share'),
          eventName: 'detailpage_Twittershare',
          icon: 'article/twitter',
          bgColor: '#333333',
        },
        telegram: {
          url: `https://t.me/share/url?url=${articleUrl.value}&text=${props.article.title}`,
          title: i18n.t('share-button.tg-share'),
          eventName: 'detailpage_Telegramshare',
          icon: 'article/telegram',
          bgColor: '#2EA2D8',
        },
        whatsapp: {
          url: `https://web.whatsapp.com/send?text=${props.article.title} ${articleUrl.value}`,
          title: i18n.t('share-button.wp-share'),
          eventName: 'detailpage_Whatsappshare',
          icon: 'article/whatsapp',
          bgColor: '#25D366',
        },
        google: {
          url: `https://news.google.com/publications/CAAqBwgKMIGmrAsw_rDEAw?ceid=TR:tr&oc=3&hl=tr&gl=TR`,
          title: 'Google News',
          eventName: 'detailpage_Googlenews',
          icon: 'article/google',
          bgColor: '#4486F4',
        },
        copy: {
          url: '',
          title: i18n.t('share-button.copy-link'),
          eventName: 'detailpage_copyURL',
          icon: 'article/link',
          bgColor: '#FFFFFF',
        },
      };
    };

    const share = computed(() => shareConstant()[props.buttonType]);

    const { toastSuccess } = useToast();

    const copyUrl = () => {
      const copy = require('copy-to-clipboard');
      if (!props.isKesfet) $analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_copyURL');
      copy(HOST_URL + getArticleUrl({ article: props.article }));
      toastSuccess(i18n.t('main.copied'));
    };

    return { handleClick, copyUrl, share };
  },
});
</script>
